module.exports = __webpack_public_path__ + "img/3_modules.3b193265.png";